/* eslint-disable import/extensions */
/* eslint-disable react/display-name */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React from 'react';
import * as Page from 'Pages';

const RoutesSchema = {
  authorized: [
    {
      name: 'Pipeline',
      path: '/pipelines',
      render: (props) => <Page.Ingestion {...props} />,
      exact: true,
      nested: [
        {
          name: 'New Pipeline',
          path: '/pipelines/new',
          render: (props) => <Page.NewPipeline {...props} />,
          exact: true
        },
        {
          name: 'Pipeline Details',
          path: '/pipelines/:pipelineId/edit',
          render: (props) => <Page.PipelineDetails {...props} />,
          exact: true
        }
      ]
    },
    {
      name: 'Transform',
      path: '/transformations',
      render: (props) => <Page.Transformation {...props} />,
      nested: [
        {
          name: 'Transformation Details',
          path: '/transformations/:transformationId',
          render: (props) => <Page.TransformationDetails {...props} />,
          exact: true
        }
      ],
      exact: true
    },
    {
      name: 'Visualize',
      path: '/visualization',
      render: (props) => <Page.Visualization {...props} />,
      exact: true,
      nested: [
        {
          name: 'Superset Visualization',
          path: '/visualization/superset',
          render: (props) => <Page.Visualization {...props} />,
          exact: true
        }
      ]
    },
    {
      name: 'Sandbox',
      path: '/sandbox',
      render: (props) => <Page.Sandbox {...props} />,
      exact: true
    },
    {
      name: 'Add-ons',
      path: '/addons',
      render: (props) => <Page.Addons {...props} />,
      // nested: [
      //   {
      //     name: 'Addon Details',
      //     path: '/addons/:addonId',
      //     render: (props) => <Page.AddonDetails {...props} />,
      //     exact: true
      //   }
      // ],
      exact: true
    }
    // {
    //   name: 'Management',
    //   path: '/management',
    //   render: () => null,
    //   exact: true,
    //   siblings: [
    //     {
    //       name: 'Users',
    //       path: '/users',
    //       render: (props) => <Page.ManageUsers {...props} />,
    //       exact: true
    //     }
    //   ]
    // }
  ],
  unauthorized: [
    {
      name: 'login',
      path: '/login',
      render: (props) => <Page.Login {...props} />,
      exact: true
    },
    {
      name: 'callback',
      path: '/callback',
      render: (props) => <Page.Callback {...props} />,
      exact: true
    },
    {
      name: 'register',
      path: '/register',
      render: (props) => <Page.Register {...props} />,
      exact: true
    },
    {
      name: 'inviteUsers',
      path: '/invite',
      render: (props) => <Page.Invite {...props} />,
      exact: true
    }
  ]
};

export default RoutesSchema;
